import { isValidInventoryQuantity, normalizeInventoryQuantity } from "../../../../pages/dashboard/inventory/inventory-quantity";
import { resolveCostStatusForSave } from "./count-cost";

export function countItemsForSave(items) {
  return items.filter((item) =>
    (item.product_id || item.product || item.description?.trim())
    && isValidInventoryQuantity(item.quantity, { allowZero: true })
  ).map((item) => {
    const purchase_price = item.purchase_price !== "" && item.purchase_price != null
      ? Number(item.purchase_price)
      : (item.product?.purchase_price ?? 0);
    return {
      product_id: item.product_id || item.product?.id || null,
      quantity: normalizeInventoryQuantity(item.quantity),
      purchase_price,
      cost_status: resolveCostStatusForSave(purchase_price, item.cost_status),
      note: item.note || item.description || "",
    };
  });
}
